import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/components/Layout.jsx");
import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/components/Quiz.jsx")